import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { AppStateInterface } from "../../../store/appState.interface";
import { invokeCalculateTotalLPPriceByCampanyNames } from "../../../store/locationPartner/location-partner.action";
import {
  TotalPrice,
  TotalPriceWithDiscount,
} from "../../models/calcul/totalPrice";
import { LocationAvailabilityEnum } from "../../enum/location-availability";
import { DateFilter } from "../../models/date-filte.interface";
import { ObjectiveTypeEnum } from "../../enum/objectives";
import { LocationSearchMethod } from "../../enum/locationSearchMethod";

@Injectable({
  providedIn: "root",
})
export class NewCampaignCalculatorService {
  constructor(private store: Store<AppStateInterface>) {}

  onSelectCalculatePrice(
    startDate: Date | null,
    endDate: Date | null,
    objective: ObjectiveTypeEnum,
    calculationMethod: LocationSearchMethod,
    locations: string[]
  ) {
    if (endDate != null && objective != null && startDate != null) {
      this.store.dispatch(
        invokeCalculateTotalLPPriceByCampanyNames({
          calculatePrice: {
            calculationMethod: calculationMethod,
            objectiveName: objective,
            startDate: startDate,
            endDate: endDate,
            names: locations,
            checkDates: true,
          },
        })
      );
    }
  }

  calculatePricePerView(locations: TotalPriceWithDiscount): number {
    var pricePerView: number = 0;
    locations.totalPricePerDay.forEach((e) => {
      if (e.pricePerView != "NaN")
        if (
          e.availabilities.availabilityStatus !=
          LocationAvailabilityEnum.NOT_AVAILABLE
        ) {
          pricePerView += e.pricePerView * locations.discount;
        }
    });
    return pricePerView;
  }

  calculateSellingPricePerDayByPriceDto(
    locations: TotalPriceWithDiscount
  ): number {
    var sellingPrice: number = 0;
    locations.totalPricePerDay.forEach((e) => {
      if (e.sellingPrice != "NaN")
        if (
          e.availabilities.availabilityStatus !=
          LocationAvailabilityEnum.NOT_AVAILABLE
        ) {
          sellingPrice += e.sellingPrice * locations.discount;
        }
    });
    return sellingPrice;
  }

  calculateTotalPrice(locations: TotalPriceWithDiscount, days: number): number {
    var totalPrice: number = 0;
    locations.totalPricePerDay.forEach((e) => {
      if (e.sellingPrice != "NaN")
        switch (e.availabilities.availabilityStatus) {
          case LocationAvailabilityEnum.AVAILABLE:
            totalPrice += e.sellingPrice * locations.discount * days;
            break;

          case LocationAvailabilityEnum.PARTIALLY:
            const totalAvailableDays: number = this.calculateTotalAvailableDays(
              e.availabilities.listOfUnpaidBookingIntervals
            );

            totalPrice +=
              e.sellingPrice * locations.discount * totalAvailableDays;
            break;

          default:
            break;
        }
    });
    return totalPrice;
  }

  calculateTotalAvailableDays(listOfUnpaidBookingIntervals: DateFilter[]) {
    let totalAvailableDays: number = 0;
    listOfUnpaidBookingIntervals.forEach((rangeDate) => {
      totalAvailableDays += this.calculateDays(
        rangeDate.startDate,
        rangeDate.endDate
      );
    });
    return totalAvailableDays;
  }

  //Calculating views
  calculateImpressionsPerDay(locations: TotalPriceWithDiscount): number {
    var impressionsPerDay: number = 0;
    locations.totalPricePerDay.forEach((e) => {
      if (e.pricePerDay != "NaN")
        if (
          e.availabilities.availabilityStatus !=
          LocationAvailabilityEnum.NOT_AVAILABLE
        ) {
          impressionsPerDay += e.viewsPerDay;
        }
    });
    return impressionsPerDay;
  }

  calculateTotalImpressions(
    locations: TotalPriceWithDiscount,
    days: number
  ): number {
    var impressionsPerDay: number = 0;
    locations.totalPricePerDay.forEach((e) => {
      if (e.pricePerDay != "NaN")
        switch (e.availabilities.availabilityStatus) {
          case LocationAvailabilityEnum.AVAILABLE:
            impressionsPerDay += e.viewsPerDay * days;
            break;

          case LocationAvailabilityEnum.PARTIALLY:
            const totalAvailableDays: number = this.calculateTotalAvailableDays(
              e.availabilities.listOfUnpaidBookingIntervals
            );
            impressionsPerDay += e.viewsPerDay * totalAvailableDays;
            break;

          case LocationAvailabilityEnum.NOT_AVAILABLE:
            break;
        }
    });
    return impressionsPerDay;
  }

  calculateDays(startDate: Date | null, endDate: Date | null): number {
    if (startDate && endDate) {
      const start = new Date(startDate);
      const end = new Date(endDate);
      const timeDiff = Math.abs(end.getTime() - start.getTime());
      return Math.ceil(timeDiff / (1000 * 3600 * 24)) + 1;
    } else return 0;
  }

  calculatePriceForEachLocation(
    totalPrice: TotalPrice,
    discount: number,
    listBookingIntervals: DateFilter[]
  ): number {
    var result: number = 0;

    const totalAvailableDays: number =
      this.calculateTotalAvailableDays(listBookingIntervals);
    return (result = totalPrice.pricePerDay * discount * totalAvailableDays);
  }

  calculateTotalPricePerLocation(
    location: TotalPrice,
    discount: number,
    days: number
  ): number {
    var totalPrice: number = 0;
    if (location.sellingPrice != "NaN")
      totalPrice += location.sellingPrice * discount * days;
    return totalPrice;
  }
}
